import React from 'react';
import { Alert } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './AlertBox.module.less';

const AlertBox = ({ ecmContent, disablePadding }) => {
  const { content, contentJson: { type } = {} } = ecmContent;
  const alertClassNames = classNames(styles.alert_box_container, {
    [styles.alert_box_container_with_padding]: !disablePadding
  });

  return (
    <div className={alertClassNames}>
      <Alert type={type}>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </Alert>
    </div>
  );
};

AlertBox.propTypes = { ecmContent: PropTypes.object, disablePadding: PropTypes.bool };
AlertBox.defaultProps = {
  ecmContent: { content: '', contentJson: { type: 'info' } },
  disablePadding: false
};

export default AlertBox;
